'use es6';

import indexBy from '../lib/indexBy';
const identity = v => v;
const createPropertiesGetterFromGroups = (getGroups, mapper = identity) => () => getGroups().then(groups => mapper(indexBy(property => property.get('name'), groups.map(group => group.get('properties')).flatten(1))));
export default createPropertiesGetterFromGroups;